// Chrome permanently stops reporting LCP after the first scroll on a page. A
// horizontal scroller with `scroll-snap-type` active at initial render lets the
// browser self-correct the scroll position during layout/font settling — that
// counts as the page's first scroll and kills LCP reporting (PSI "NO_LCP"),
// even with zero JS running (confirmed on the tabs component this pattern was
// first fixed for). Fix: snap stays off until the container's `.is-snap-ready`
// class is armed by a real user interaction; the corresponding SCSS must gate
// `scroll-snap-type` behind `&.is-snap-ready`.
const SNAP_ARM_SELECTOR = '[data-scroll-snap-arm]';
const ARM_EVENTS = ['pointerdown', 'touchstart', 'wheel', 'keydown'];

function armSnapContainers() {
	document.querySelectorAll(SNAP_ARM_SELECTOR).forEach(el => {
		const arm = () => el.classList.add('is-snap-ready');
		ARM_EVENTS.forEach(evt => el.addEventListener(evt, arm, { once: true, passive: true }));
	});
}

if (document.readyState === 'loading') {
	document.addEventListener('DOMContentLoaded', armSnapContainers);
} else {
	armSnapContainers();
}
